import { DELETE_ATTRIBUTE, DELETE_ATTRIBUTE_SUCCESS, DELETE_ATTRIBUTE_ERROR, DELETE_ATTRIBUTE_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DeleteAttribute = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ATTRIBUTE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DELETE_ATTRIBUTE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DELETE_ATTRIBUTE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DELETE_ATTRIBUTE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DeleteAttribute;
